module.exports = __webpack_public_path__ + "static/media/3136.c024c7b7.jpg";